const PRODUCT_KEY = 'source';
const PRODUCT_ID_KEY = 'source_id';
export default function addUrlParams(url) {
    if (!url) {
        return url;
    }
    // split URL by ? and # to get query and hash params
    const [urlWithoutParams, queryParams, hashParams] = url.split(/[?#]/);
    // get url search params from url string
    const urlSearchParams = new URLSearchParams(queryParams);
    // add current product and product ID to query params (if present on Context)
    const ctx = window.SilverSurferSDK.getContext().current;
    if (ctx) {
        if (typeof ctx.product === 'string') {
            urlSearchParams.set(PRODUCT_KEY, ctx.product);
        }
        if (typeof ctx.productId === 'string') {
            urlSearchParams.set(PRODUCT_ID_KEY, ctx.productId);
        }
    }
    // reconstruct the URL
    return (urlWithoutParams +
        (urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '') +
        (hashParams ? `#${hashParams}` : ''));
}
